import { render } from "./QuestionCategoryHeader.vue?vue&type=template&id=5181ffdc&scoped=true&ts=true"
import script from "./QuestionCategoryHeader.vue?vue&type=script&lang=ts"
export * from "./QuestionCategoryHeader.vue?vue&type=script&lang=ts"

import "./QuestionCategoryHeader.vue?vue&type=style&index=0&id=5181ffdc&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5181ffdc"]])

export default __exports__